<template>
  <RsIconDisplay
    :icon-key="iconChangeCount"
    :icon-class="iconClass"
    :transform="transform"
    @click="$emit('click', $event)"
  />
</template>
<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'RsIcon',

  props: {
    icon: {
      type: String,
      default: '',
      required: true,
    },
    /** *
     * FontAwesome icon weights: far | fas | fal | fad
     */
    weight: {
      type: String,
      default: 'fal',
    },
    transform: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      iconClass: '',
      iconChangeCount: 0,
    };
  },
  watch: {
    $props: {
      handler() {
        this.iconClass = `rs-icon fa-fw fa-${this.icon} ${this.weight}`;
        this.iconChangeCount += 1;
      },
      deep: true,
      immediate: true,
    },
  },
});
</script>
